import { Link } from 'react-router-dom'

const LANGUAGES = [
    { code: 'tr', short: 'TR', label: 'Türkçe' },
    { code: 'en', short: 'EN', label: 'English' },
    { code: 'de', short: 'DE', label: 'Deutsch' },
]

/**
 * Segmented TR / EN / DE switch. Three options are always visible (one click,
 * no dropdown); each links to the equivalent route in that locale.
 *
 * @param {{ currentLang: 'tr' | 'en' | 'de', links: { tr: string, en: string, de: string }, label?: string }} props
 */
export default function LanguageSwitcher({ currentLang, links, label = 'Language' }) {
    return (
        <nav className="lang-switcher" aria-label={label}>
            <ul className="lang-list">
                {LANGUAGES.map(({ code, short, label: name }) => {
                    const isCurrent = code === currentLang
                    return (
                        <li key={code}>
                            {isCurrent ? (
                                <span className="lang-item" aria-current="true" lang={code} title={name}>
                                    <span aria-hidden="true">{short}</span>
                                    <span className="sr-only">{name}</span>
                                </span>
                            ) : (
                                <Link
                                    to={links[code] || '/'}
                                    className="lang-item"
                                    hrefLang={code}
                                    lang={code}
                                    title={name}
                                    viewTransition
                                >
                                    <span aria-hidden="true">{short}</span>
                                    <span className="sr-only">{name}</span>
                                </Link>
                            )}
                        </li>
                    )
                })}
            </ul>
        </nav>
    )
}
